import axios, { AxiosResponse } from 'axios';
import {
  TPendingMerchantReq,
  TPendingMerchantRes,
} from '@src/types/pendingMerchant.ts';

export const getPendingMerchants = (
  params?: TPendingMerchantReq
): Promise<AxiosResponse<TPendingMerchantRes>> => {
  return axios.get('/pending-merchant/', { params });
};
